import { render, staticRenderFns } from "./CrowdstakingDashboardCard.vue?vue&type=template&id=96cfae2e&scoped=true&"
import script from "./CrowdstakingDashboardCard.vue?vue&type=script&lang=js&"
export * from "./CrowdstakingDashboardCard.vue?vue&type=script&lang=js&"
import style0 from "./CrowdstakingDashboardCard.vue?vue&type=style&index=0&id=96cfae2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cfae2e",
  null
  
)

export default component.exports